import { createRouter } from 'sv-router';
import Layout from '../pages/Layout.svelte';
import NotFound from '../pages/NotFound.svelte';

export const { p, navigate, isActive, route } = createRouter({
  '/': () => import('../pages/Tournaments.svelte'),
  '/tournament/:tournamentId': () => import('../pages/Tournament.svelte'),
  '/tournament/:tournamentId/live': () => import('../pages/Tournament.svelte'),
  '/tournament/:tournamentId/live/:roundId/setsolution': () =>
    import('../pages/Tournament.svelte'),
  '/tournament/:tournamentId/edit': () => import('../pages/Tournament.svelte'),
  '/tournament/:tournamentId/winners': () =>
    import('../pages/Tournament.svelte'),
  '/tournament/:tournamentId/daily-leaderboard': () =>
    import('../pages/DailyLeaderboardPage.svelte'),
  '/tournament/:tournamentId/rescore': () =>
    import('../pages/RescoreInteractionDay.svelte'),
  '/tournament/:tournamentId/interactionday/:dayKey': () =>
    import('../pages/Tournament.svelte'),
  '/tournament/:tournamentId/interactionday/:dayKey/round/:roundId': () =>
    import('../pages/Tournament.svelte'),
  '/tournament/:tournamentId/interactionday/:dayKey/round/:roundId/create':
    () => import('../pages/Tournament.svelte'),
  '/tournament/:tournamentId/interactionday/:dayKey/round/:roundId/question/:questionId':
    () => import('../pages/Tournament.svelte'),
  '/tournament/:tournamentId/interactionday/:dayKey/round/:roundId/question/:questionId/edit':
    () => import('../pages/Tournament.svelte'),
  '/tournament/:tournamentId/round/:roundId': () =>
    import('../pages/Tournament.svelte'),
  '/tournament/:tournamentId/round/:roundId/create': () =>
    import('../pages/Tournament.svelte'),
  '/tournament/:tournamentId/round/:roundId/question/:questionId': () =>
    import('../pages/Tournament.svelte'),
  '/tournament/:tournamentId/round/:roundId/question/:questionId/edit': () =>
    import('../pages/Tournament.svelte'),
  '/tournament/:tournamentId/questions/jsonedit': () =>
    import('../pages/QuestionJsonEdit.svelte'),
  '*': NotFound,
  layout: Layout,
});
